export const COMPANY = {
  name: "Altmuligmanden Juelsminde",
  cvr: "41704209",
  phone: "27892064",
  phoneFormatted: "+45 27 89 20 64",
  email: "jonasvilhelmsen@outlook.dk",
  address: "Odelsgade 26 2. th., 7130 Juelsminde",
  city: "Juelsminde",
  postalCode: "7130",
  owner: "Jonas Vilhelmsen",
  tagline: "Din lokale hjælp til små og store opgaver",
  logoImage: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1851_1.jpeg",
  heroImage: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2498.jpeg",
  aboutImage: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1851.jpeg"
};

export const CUSTOMER_IMAGES = [
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2688458725.jpg", title: "Flytning og transport", category: "flytning-transport" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2498.jpeg", title: "Montering og inventar", category: "montering" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1978.jpeg", title: "Montering og inventar", category: "montering" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1980.jpeg", title: "Montering og inventar", category: "montering" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1979.jpeg", title: "Montering og inventar", category: "montering" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1851.jpeg", title: "Udført håndværksarbejde", category: "generel-vedligeholdelse" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2119.jpeg", title: "Rydningsopgave", category: "rydning" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg", title: "Oprydning og bortskaffelse", category: "rydning" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2086.jpeg", title: "Vedligeholdelse i hjemmet", category: "generel-vedligeholdelse" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg", title: "Maling og vægarbejde", category: "maling-tapetsering" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2119.jpeg", title: "Klargøring af vægge", category: "maling-tapetsering" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2727590971-rez.jpg", title: "Reparation i hjemmet", category: "reparationer" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1748.jpeg", title: "Havearbejde og udendørs opgaver", category: "havearbejde" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1749.jpeg", title: "Havearbejde og udendørs opgaver", category: "havearbejde" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1750.jpeg", title: "Havearbejde og udendørs opgaver", category: "havearbejde" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1591.jpeg", title: "Udendørs vedligeholdelse", category: "havearbejde" },
  { url: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1314.jpeg", title: "Havearbejde i Juelsminde", category: "havearbejde" }
];

export const DEFAULT_GALLERY = [
  {
    id: "havearbejde",
    title: "Havearbejde og beskæring",
    category_slug: "havearbejde",
    description: "Klipning, pasning og vedligeholdelse i privat have i Juelsminde.",
    image: [
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1314.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1591.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1750.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1748.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1749.jpeg"
    ]
  },
  {
    id: "montering",
    title: "Montering af møbler og inventar",
    category_slug: "montering",
    description: "Montering og solid ophængning af inventar og møbler.",
    image: [
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2498.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1978.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1980.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1979.jpeg"
    ]
  },
  {
    id: "reparationer",
    title: "Reparation i hjemmet",
    category_slug: "reparationer",
    description: "Hurtig og præcis udbedring af reparationer i boligen.",
    image: [
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2727590971-rez.jpg"
    ]
  },
  {
    id: "flytning-transport",
    title: "Flyttehjælp og transport",
    category_slug: "flytning-transport",
    description: "Flyttehjælp og sikker transport med professionel bil og trailer.",
    image: [
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2688458725.jpg"
    ]
  },
  {
    id: "maling-tapetsering",
    title: "Malerarbejde i bolig",
    category_slug: "maling-tapetsering",
    description: "Maling og klargøring af overflader og vægge.",
    image: [
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2119.jpeg"
    ]
  },
  {
    id: "generel-vedligeholdelse",
    title: "Vedligeholdelse af bolig",
    category_slug: "generel-vedligeholdelse",
    description: "Praktisk håndværksarbejde og vedligeholdelse af boligen.",
    image: [
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2086.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1851.jpeg"
    ]
  },
  {
    id: "rydning",
    title: "Rydning og bortskaffelse",
    category_slug: "rydning",
    description: "Effektiv rydning af opbevaringsrum og bortskaffelse af affald.",
    image: [
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg",
      "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2119.jpeg"
    ]
  }
];

export const SERVICES = [
  {
    id: "reparationer",
    title: "Reparationer",
    slug: "reparationer",
    gallerySlug: "reparationer",
    icon: "fa-solid fa-screwdriver-wrench",
    shortDescription: "Reparation af defekte installationer, som vandhaner, døre og vinduer.",
    description: "Har du en dryppende vandhane, en dør der binder, eller et vindue der mangler justering? Som din lokale altmuligmand i Juelsminde rykker jeg hurtigt ud og hjælper med alle former for reparationer i hjemmet. Uanset om det er småjusteringer af beslag, reparation af låse eller udskiftning af slidte dele, sørger jeg for en pæn og holdbar løsning.",
    image: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2727590971-rez.jpg"
  },
  {
    id: "montering",
    title: "Montering",
    slug: "montering",
    gallerySlug: "montering",
    icon: "fa-solid fa-hammer",
    shortDescription: "Montering af møbler og inventar, inklusive skabe, hylder og billeder.",
    description: "Skal du have samlet nye møbler, ophængt tunge skabe, hylder, gardiner eller TV-skærme? Montering kræver præcision og de rigtige rawlplugs til vægtypen. Jeg sikrer, at dit inventar hænger snorlige og er forsvarligt fastgjort – uanset om væggen er af gips, mursten eller beton.",
    image: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2498.jpeg"
  },
  {
    id: "maling-og-tapetsering",
    title: "Maling og tapetsering",
    slug: "maling-og-tapetsering",
    gallerySlug: "maling-tapetsering",
    icon: "fa-solid fa-paint-roller",
    shortDescription: "Hjælp med maling og tapetsering, hvilket kan give dit hjem et friskt udseende.",
    description: "En ny omgang maling eller flot tapet kan forvandle ethvert rum. Jeg udfører grundigt malerarbejde indendørs og udendørs med fokus på afdækning, spartling og ordentlig efterbehandling. Lad mig klare det tunge forarbejde og give dine vægge, lofter og træværk et flot og holdbart finish.",
    image: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg"
  },
  {
    id: "havearbejde",
    title: "Havearbejde",
    slug: "havearbejde",
    gallerySlug: "havearbejde",
    icon: "fa-solid fa-leaf",
    shortDescription: "Havearbejde og vedligeholdelse af udendørsområder, herunder græsslåning og beskæring af buske.",
    description: "Nyd din have uden besværet. Jeg tilbyder hjælp til græsslåning, hækklipning, beskæring af buske, lugning og generel vedligeholdelse af din grund i Juelsminde og omegn. Uanset om du ønsker fast pasning eller en enkeltstående oprydning i haven, står jeg klar.",
    image: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-1314.jpeg"
  },
  {
    id: "flytning-og-transport",
    title: "Flytning og transport",
    slug: "flytning-og-transport",
    gallerySlug: "flytning-transport",
    icon: "fa-solid fa-truck-moving",
    shortDescription: "Flytning og transport af møbler og ting.",
    description: "Mangler du en ekstra stærk hånd eller transport til flytning af møbler, tunge genstande eller byggematerialer? Jeg hjælper med skånsom bæring og sikker transport. Jeg passer godt på dine ting undervejs, så flytningen forløber trygt og ubesværet.",
    image: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/shutterstock-2688458725.jpg"
  },
  {
    id: "rydning",
    title: "Rydning",
    slug: "rydning",
    gallerySlug: "rydning",
    icon: "fa-solid fa-broom",
    shortDescription: "Rydning af loft eller kælder, herunder bortskaffelse af affald.",
    description: "Er loftet, kælderen, skuret eller garagen fyldt til randen? Jeg hjælper med hurtig og effektiv rydning samt korrekt bortskaffelse af affald på genbrugspladsen. Du slipper for at slæbe tunge genstande og køre frem og tilbage – jeg tager mig af hele oprydningen.",
    image: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2118.jpeg"
  },
  {
    id: "generel-vedligeholdelse",
    title: "Generel vedligeholdelse",
    slug: "generel-vedligeholdelse",
    gallerySlug: "generel-vedligeholdelse",
    icon: "fa-solid fa-house-chimney-crack",
    shortDescription: "Generel vedligeholdelse og reparation i hjemmet – fra at skifte pærer til at lappe vægge.",
    description: "Løbende vedligeholdelse holder din bolig i pæn og sund stand. Jeg hjælper med alle de små og mellemstore opgaver, der hober sig op i hverdagen. Fra udskiftning af pærer og tætningslister til lapning af slåede huller i væggen, rensning af tagrender og smøring af hængsler.",
    image: "https://assets.auxodev.dk/assets/3afae24a-c90c-4b91-94fe-484783460244/img-2086.jpeg"
  }
];
